export enum ModalNavigationEnum {
    ACCOUNT_SETTINGS = 'account-settings',
    AUTOMATION_SETTINGS = 'automation-settings',
    COMPANY_NEWS_ALERT_SETUP = 'news-alert-setup',
    DYNAMICS = 'dynamics',
    FILE_CENTER = 'file-center',
    HUBSPOT = 'hubspot',
    ICP_AUTOMATIONS = 'icp-automations',
    INTENT_SETTINGS = 'intent-settings',
    JOB_CHANGE_AUTOMATIONS = 'job-change-automations',
    MANAGE_TAGS = 'manage-tags',
    MARKETO = 'marketo',
    OUTREACH = 'outreach',
    SALESFORCE = 'salesforce',
    SALESLOFT = 'salesloft',
    SUCCESS_CENTER = 'success-center',
    TECHNOGRAPHICS = 'technographics',
    VISITOR_INTEL_AUTOMATIONS = 'visitor-intel-automations',
    ZOHO = 'zoho',
  }
